export const GlobalVar = {
  SHOWCOUNT: 20,
  SIZE: 'small'
}
